const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

let scriptLoaded = false;
let scriptLoading = false;
const pendingCallbacks = [];

function loadScript() {
  if (scriptLoaded || !SITE_KEY) return Promise.resolve();
  if (scriptLoading) return new Promise((resolve) => pendingCallbacks.push(resolve));
  scriptLoading = true;
  return new Promise((resolve) => {
    pendingCallbacks.push(resolve);
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.async = true;
    script.onload = () => {
      scriptLoaded = true;
      scriptLoading = false;
      pendingCallbacks.forEach((cb) => cb());
      pendingCallbacks.length = 0;
    };
    script.onerror = () => {
      scriptLoading = false;
      pendingCallbacks.forEach((cb) => cb());
      pendingCallbacks.length = 0;
    };
    document.head.appendChild(script);
  });
}

export async function executeRecaptcha(action = 'submit') {
  if (!SITE_KEY) return '';
  await loadScript();
  if (!window.grecaptcha) return '';
  return new Promise((resolve) => {
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(SITE_KEY, { action });
        resolve(token);
      } catch {
        resolve('');
      }
    });
  });
}
